import React from 'react'
import Button from '@material-ui/core/Button'
import { useAuth } from 'lib/auth'
import {
  getRegistrationClosedEffective,
  getRegistrationDisabled,
} from '../registration-cta-utils'

const ActionButton = ({
  groupEvent,
  paymentRequired,
  steps,
  activeStep,
  type,
  component,
  to,
  onClick,
}) => {
  const { user } = useAuth()
  const { isCanceled, registrationFull } = groupEvent

  const registrationClosedEffective = getRegistrationClosedEffective({
    user,
    groupEvent,
  })
  const registrationDisabled = getRegistrationDisabled({ user, groupEvent })

  const nextStep = steps[activeStep + 1]

  const label = (() => {
    if (isCanceled) return 'Event Canceled'
    if (registrationClosedEffective) return 'Registration Closed'
    if (registrationFull) return 'Registration Full'
    if (nextStep && nextStep.name === 'Waiver') return 'Continue'
    if (paymentRequired) return 'Review and Pay'
    return 'Register'
  })()

  return (
    <Button
      variant="contained"
      color="primary"
      disabled={registrationDisabled}
      {...{ type, component, to, onClick }}
    >
      {label}
    </Button>
  )
}

export default ActionButton
